import {Button, Icon, Header, Segment, Transition} from "semantic-ui-react";
import React, {Component} from "react";
import {Input, Dropdown, Form, Modal, Container} from 'semantic-ui-react'
import Countdown from 'react-countdown';
import { isMobile } from 'react-device-detect';


// Renderer callback with condition
const format = (n) => {
    return n > 9 ? n : `0${n}`;
}
const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
        // Render a completed state
        return <div />;
    } else {
        // Render a countdown
        return (
            <>
            <div style={{marginBottom: 3}}>
                <span style={{color: 'dodgerblue', fontWeight: 'bold'}}>%50</span> discount coupon!
            </div>
            <div style={{marginBottom: 3}}>
                Coupon:
            </div>
            <div style={{marginBottom: 3}}>
                <Header as='h3' style={{color: '#f3701d'}}>
                    QQEMA
                </Header>
            </div>
            <div style={{marginBottom: 3}}>
                Offer ends at:
            </div>
            <div style={{marginBottom: 0}}>

                <Header as='h3' style={{color: '#f3701d' }}>
                    {format(days)} : {format(hours)} : {format(minutes)} : {format(seconds)}
                </Header>

            </div>
            <div>
                <h6 style={{marginTop: 0}}>
                <span style={{paddingLeft: 2}}>DYS</span>
                <span style={{paddingLeft: 15}}>HRS</span>
                <span style={{paddingLeft: 14}}>MIN</span>
                <span style={{paddingLeft: 15}}>SEC</span>
                </h6>
            </div>
            </>

        )
    }
};

export default class ActionMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: true
        };
    }

    render(){
        const { cta } = this.props;
        const messageBody = cta?.message?.body;
        const marginLeft = isMobile ? 8 : 150;
        
        return this.state.isVisible ? (
            <Transition
                animation="shake"
                duration={1000}
                visible={this.props.limited}
            >
                <Segment
                    style={{
                        padding: 9,
                        marginLeft: marginLeft,
                        color: 'black',
                        background: '#ffefee',
                        width: 450,
                        left: 10,
                        position: 'fixed',
                        bottom: 7,
                        zIndex: 1000,
                        overflow: 'auto', // Ensure content doesn't overflow
                        maxHeight: 'calc(100vh - 20px)', // Maximum height relative to the viewport, with some space
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                    }}
                >
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                        <Header style={{
                            marginBottom: 0,
                            paddingRight: '40px',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                            msUserSelect: 'none'
                        }} textAlign='center'>{this.props.cta?.title || l.demo_mode}</Header>
                        <Button
                            icon
                            basic
                            compact
                            onClick={() => {
                                this.setState({isVisible: false});
                                this.props.setLimitation(false);
                                this.props.setLimited(false);
                                }
                            }
                            style={{
                                position: 'absolute',
                                right: '-10px',
                                top: '-10px',
                                padding: 0,
                                margin: 0,
                                width: '30px',
                                height: '30px',
                                minHeight: '30px',
                                minWidth: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '4px'
                            }}
                        >
                            <Icon 
                                name='remove' 
                                style={{ 
                                    margin: 0, 
                                    padding: 0,
                                    fontSize: '14px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: '100%',
                                    position: 'relative',
                                    top: '1px',  // Adjust this value as needed
                                    left: '1px'  // Adjust this value as needed
                                }} 
                            />
                        </Button>
                        <hr style={{ width: '100%', borderTop: '1px solid #ccc', marginBottom: 15 }} /> {/* Separator line */}
                        <div style={{ 
                            fontSize: 'initial', 
                            paddingBottom: 15, 
                            textAlign: 'center',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                            msUserSelect: 'none'
                        }}>
                            {messageBody ? 
                                <div dangerouslySetInnerHTML={{ __html: messageBody }} /> 
                                : <p>{l.limitation_message}</p>
                            }
                        </div>
                    </div>


                    <Button
                        style={{ fontSize: 'initial', backgroundColor:'#75b813', color: '#ffffff' }}
                        onClick={() => window.open(this.props.cta?.url || "/pricing-table", '_blank')}
                        content={this.props.cta?.button_text || l.limitation_message3 + "!"}
                    />
                </Segment>
            </Transition>
        ) : <div></div>;
    }
}
